function pad2(n: number): string {
    return String(n).padStart(2, '0');
}

/** Local calendar date as `YYYY-MM-DD` (HTML `input[type=date]`). */
export function localCalendarDateOnly(now: Date = new Date()): string {
    return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}

/** Local calendar date `daysAgo` days before `now` as `YYYY-MM-DD`. */
export function localCalendarDateOnlyDaysAgo(daysAgo: number, now: Date = new Date()): string {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysAgo);
    return localCalendarDateOnly(d);
}
